import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CompaniesService } from 'src/app/services/yardscore-services/companies.service';
@Component({
  selector: 'app-users-list-v2',
  templateUrl: './users-list-v2.component.html',
  styleUrls: ['./users-list-v2.component.css']
})
export class UsersListV2Component implements OnInit {
  users: any[] = [];
  filteredUsers: any[] = [];
  searchTerm: string = '';
  constructor(
    private route: ActivatedRoute,
    private companiesService: CompaniesService
  ) { }

  ngOnInit(): void {
    this.loadCompanyUsers();
  }

  loadCompanyUsers(): void {
    this.companiesService.getAllUsers().subscribe(response => {
      this.users = response;
      this.filteredUsers = [...response];
      this.filteredUsers.sort((firstUser, secondUser) => secondUser.id - firstUser.id);

    }, error => {
      console.error('Error fetching users:', error);
    });
  }
  filterOptions(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredUsers = this.users.filter(user =>
      user.fullName.toLowerCase().includes(term)||
      user.email.toLowerCase().includes(term)

    );
  }
}